import { Component } from 'react';
import { saveAsDraft, validateForm } from 'redux/ducks/CreateEvent';

class CreateEventStepBase extends Component {
  fileReader = new FileReader();
  PAGE_NUM = 0;
  successAction = null;
  state = {};

  onSaveAsDraft = () => {
    this.props.dispatch(saveAsDraft())
  }

  pageIsValid() {
    return false;
  }

  onSaveAndContinue = () => {
    if (this.pageIsValid()) {
      if(this.successAction) {
        this.props.dispatch(this.successAction);
      }
    } else {
      this.props.dispatch(validateForm(this.PAGE_NUM))
    }
  }

}

export default CreateEventStepBase;